import instance from '.'
import { err, getResult } from '../utils/functions'
import { APIResult } from '../utils/types'
import { Game } from './types/games'

export function getGames(): Promise<APIResult<Game[]>> {
  return instance
    .get('/api/game')
    .catch((e) => err(e))
    .then((res) => getResult<Game[]>(res))
}
